import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, isMsalConfigured } from './auth/msalConfig';
import AuthGuard from './auth/AuthGuard';
import PortalShell from './components/PortalShell';

/**
 * When MSAL is configured, wrap the app in MsalProvider + AuthGuard.
 * When not configured (local dev), render the portal directly.
 */
export default function App() {
  if (!isMsalConfigured || !msalInstance) {
    return <PortalShell />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthGuard>
        <PortalShell />
      </AuthGuard>
    </MsalProvider>
  );
}
